import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { Button } from "../../button/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setShowLoginModalAction } from "../../../store/actions/ui";
import { getLocalizedPath } from '../../../utils/lang';
import logo from '../../../images/logo.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { StyledHeader } from "./header.style";
import { useTranslation } from 'react-i18next';
import { supportedLngs } from "../../../i18n";

export const Header = () => {

  const location = useLocation();
  const userFirebase = useSelector((state: RootState) => state.user.userFirebase);
  const userInfo = useSelector((state: RootState) => state.user.userInfo);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [showSubHeader, setShowSubHeader] = useState<boolean>(false);
  
  const handleClickLogin = () => {
    dispatch(setShowLoginModalAction(true));
  };
  const [isMobileMenuOpened, setIsMobileMenuOpened] = useState<boolean>(false);
  const handleToggleSubHeader = () => {
    setShowSubHeader(!showSubHeader);
  };

  // Helper to replace the language code in the path
  const handleLanguageChange = (lng: string) => {
    if (i18n.language === lng) return;
    // Assume URL structure: /:lng/...
    const pathParts = location.pathname.split('/');
    if (supportedLngs.includes(pathParts[1])) {
      pathParts[1] = lng;
    } else {
      pathParts.splice(1, 0, lng);
    }
    const newPath = pathParts.join('/') + location.search + location.hash;
    i18n.changeLanguage(lng);
    navigate(newPath, { replace: true });
  };

  return (
    <StyledHeader>
      <div className="header-desktop">
        <div>
          <Link to={getLocalizedPath("/")}><img src={logo} alt="illustroke logo" /></Link>
        </div>
        <div className="elements">
          <Link to={getLocalizedPath("/")} className={(location.pathname === '/' ? 'active' : '')}>{t('header_home')}</Link>
          <Link to={getLocalizedPath("/pricing")} className={(location.pathname === '/pricing' ? 'active' : '')}>{t('header_pricing')}</Link>
          <Link to={getLocalizedPath("/api")} className={(location.pathname === '/api' ? 'active' : '')}>{t('header_api')}</Link>
          <button onClick={handleToggleSubHeader} className="ai-tools" >
            {showSubHeader ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
            {t('header_ai_tools')}
          </button>
          {userFirebase ? (
            <>
              <Link to={getLocalizedPath("/collection")} className={(location.pathname === '/collection' ? 'active' : '')}>{t('header_collection')}</Link>
              <Link to={getLocalizedPath("/designs")} className={(location.pathname === '/designs' ? 'active' : '')}>{t('header_designs')}</Link>
              <Link to={getLocalizedPath("/profile")} className={(location.pathname === '/profile' ? 'active' : '')}>{t('header_my_profile')}</Link>

              <select
                value={i18n.language}
                onChange={e => handleLanguageChange(e.target.value)}
                aria-label="Select language"
                className="language-select"
                name="language-select"
                id="language-select"
              >
                {supportedLngs.map(lng => (
                  <option key={lng} value={lng}>
                    {lng.toUpperCase()}
                  </option>
                ))}
              </select>

              {userInfo?.tokens !== undefined && (
                <Link to={getLocalizedPath("/pricing")}>
                  <div className="tokens">
                    <p>{userInfo?.tokens} {t('header_tokens')}</p>
                  </div>
                </Link>
              )}

            </>
          ) : (
            <Button onClick={handleClickLogin} >
              <span data-testid="header-desktop-login-button">{t('header_login')}</span>
            </Button>
          )}
        </div>
      </div>
      {showSubHeader && (
        <div className="sub-header-desktop">
          <Link to={getLocalizedPath("/")} className={(location.pathname === '/' ? 'active' : '')} onClick={handleToggleSubHeader} >{t('header_vector_illustrations')}</Link>
          <Link to={getLocalizedPath("/image-to-vector")} className={(location.pathname === '/image-to-vector' ? 'active' : '')} onClick={handleToggleSubHeader}>{t('header_image_to_vector')}</Link>
          <Link to={getLocalizedPath("/image-generator")} className={(location.pathname === '/image-generator' ? 'active' : '')} onClick={handleToggleSubHeader}>{t('header_pixel_illustrations')}</Link>
        </div>
      )}
      <div className="header-mobile">
        <div className="icons">
          <Link to={getLocalizedPath("/")}><img src={logo} alt="illustroke logo" /></Link>
          <button onClick={() => setIsMobileMenuOpened(!isMobileMenuOpened)} id="hamburger">
            <FontAwesomeIcon icon={faBars} color="white" size="2x"  />
          </button>
        </div>
        {isMobileMenuOpened && (
          <div className="elements">
            <Link onClick={() => setIsMobileMenuOpened(false)} to={getLocalizedPath("/api")}>{t('header_api')}</Link>
            <Link onClick={() => setIsMobileMenuOpened(false)} to={getLocalizedPath("/pricing")}>{t('header_pricing')}</Link>
            <Link onClick={() => setIsMobileMenuOpened(false)} to={getLocalizedPath("/image-to-vector")}>{t('header_image_to_vector')}</Link>
            <Link onClick={() => setIsMobileMenuOpened(false)} to={getLocalizedPath("/image-generator")}>{t('header_pixel_illustrations')}</Link>
            {userFirebase ? (
              <>
                <Link onClick={() => setIsMobileMenuOpened(false)} to={getLocalizedPath("/collection")}>{t('header_collection')}</Link>
                <Link onClick={() => setIsMobileMenuOpened(false)} to={getLocalizedPath("/profile")}>{t('header_my_profile')}</Link>
              </>
            ) : (
              <Button onClick={handleClickLogin}>
                <span>{t('header_login')}</span>
              </Button>
            )}
          </div>
        )}
      </div>
    </StyledHeader>
  )
};